import {
    REGISTER_USER,
    REGISTER_USER_SUCCESSFUL,
    REGISTER_USER_FAILED,
} from "./actionTypes";

const initialState = {
    registrationError: null,
    message: null,
    loading: false,
};

const account = (state = initialState, action: any) => {
    switch (action.type) {
        case REGISTER_USER:
            return {
                ...state,
                user: null,
                loading: true,
                registrationError: null,
            };
        case REGISTER_USER_SUCCESSFUL:
            return {
                ...state,
                loading: false,
                user: action.payload,
                registrationError: null,
            };
        case REGISTER_USER_FAILED:
            return {
                ...state,
                user: null,
                loading: false,
                registrationError: action.payload,
            };
        default:
            return { ...state };
    }
};

export default account;
